import AuthenticationStateContext from '@/components/App/AppSetup/AuthenticationState/AuthenticationStateContext';
import googleAccessTokenStore from '@/components/FileAttachments/AddFiles/AddFilesControls/utils/google/googleAccessTokenStore';
import useApi from '@/lib/api/useApi';
import { useMsal } from '@azure/msal-react';
import { useContext } from 'react';

const useLogout = () => {
  const api = useApi();
  const [, refreshAuthenticationState] = useContext(AuthenticationStateContext);

  const { instance: msalInstance } = useMsal();

  const logout = async (): Promise<void> => {
    api.unauthenticate();

    googleAccessTokenStore.clearAccessToken();
    await msalInstance.clearCache();

    refreshAuthenticationState();
  };

  return logout;
};

export default useLogout;
